function CapabilitiesSection() {
  return (
    <section id="capabilities" className="section">
      <div className="container">
        <div className="section-tag reveal">What We Offer</div>
        <h2 className="section-title reveal">
          Your One-Stop
          <br />
          <em>Construction Solution</em>
        </h2>
        <p className="section-desc reveal">From Dream to Reality - We Guide You Through Every Phase</p>

        <div className="cap-grid">
          <div className="cap-card reveal">
            <div className="cap-num">01</div>
            <h3>Find a Space</h3>
            <p className="cap-sub">Residential &amp; Commercial Properties</p>
            <ul>
              <li>
                <strong>Luxury Apartment Rentals</strong> - Long-term stays in premium locations with
                modern amenities
              </li>
              <li>
                <strong>Flexible Property Leasing</strong> - Commercial and residential lease agreements
                tailored to your needs
              </li>
              <li>
                <strong>Property Management</strong> - Complete upkeep and administration of rented units
              </li>
            </ul>
          </div>

          <div className="cap-card reveal">
            <div className="cap-num">02</div>
            <h3>Design a Space</h3>
            <p className="cap-sub">Architecture &amp; Interior Design</p>
            <ul>
              <li>
                <strong>Architectural Planning</strong> - Blueprints, 3D modeling, and comprehensive
                structural design
              </li>
              <li>
                <strong>Interior Design &amp; Styling</strong> - Bespoke furniture, lighting, and complete
                aesthetic planning
              </li>
              <li>
                <strong>Landscape &amp; Outdoor Design</strong> - Creating functional gardens and beautiful
                exterior spaces
              </li>
            </ul>
          </div>

          <div className="cap-card reveal">
            <div className="cap-num">03</div>
            <h3>Build a Space</h3>
            <p className="cap-sub">Construction &amp; Engineering</p>
            <ul>
              <li>
                <strong>General Contracting</strong> - End-to-end project management from groundbreaking to
                handover
              </li>
              <li>
                <strong>Civil Engineering &amp; Structural Work</strong> - Ensuring safety and integrity of
                every build
              </li>
              <li>
                <strong>Renovation &amp; Remodeling</strong> - Specialized services for updating existing
                structures
              </li>
              <li>
                <strong>A-to-Z Building Materials</strong> - Premium cement, steel, bricks, tiles, marble,
                and all finishing materials
              </li>
            </ul>
          </div>

          <div className="cap-card reveal">
            <div className="cap-num">04</div>
            <h3>Specialize a Space</h3>
            <p className="cap-sub">Smart &amp; Custom Solutions</p>
            <ul>
              <li>
                <strong>Smart Home Integration</strong> - Automation, security systems, and high-tech wiring
                solutions
              </li>
              <li>
                <strong>Modular Kitchen &amp; Wardrobe</strong> - Custom cabinetry and storage solutions
              </li>
              <li>
                <strong>Sustainability Consulting</strong> - Eco-friendly materials and solar energy
                installations
              </li>
              <li>
                <strong>Electrical &amp; Plumbing Kits</strong> - All-in-one solutions for essential
                utilities
              </li>
            </ul>
          </div>

          <div className="cap-card reveal">
            <div className="cap-num">05</div>
            <h3>Maintain a Space</h3>
            <p className="cap-sub">Repairs &amp; Facility Management</p>
            <ul>
              <li>
                <strong>Post-Completion Care</strong> - Ongoing maintenance and support services
              </li>
              <li>
                <strong>Facility Management</strong> - Complete property maintenance and operations
                oversight
              </li>
              <li>
                <strong>Emergency Repairs</strong> - 24/7 rapid response for urgent maintenance needs
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CapabilitiesSection;
